import { useState } from "react";
import { toast } from "react-toastify";
import logo from "../../assets/images/logo.svg";

const LoginForm = (props: any) => {
  const { onLogin, onLoginSuccess } = props;

  const [userInfo, setUserInfo] = useState({
    username: "",
    password: "",
  });

  const handleSubmit =  (event: React.FormEvent) => {
    event.preventDefault();
    onLogin(userInfo.username, userInfo.password).then((response: any) =>{
      onLoginSuccess(response)
    }
    
    ).catch((e: Error)=>{
      toast.error(e.message)
      
    });
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <div className="brand-logo">
                  <img src={logo} alt="logo" />
                </div>
                <h4>Hello! let's get started</h4>
                <h6 className="fw-light">Sign in to continue.</h6>
                <form className="pt-3">
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      id="exampleInputEmail1"
                      placeholder="Username"
                      onChange={(e)=>setUserInfo({
                        ...userInfo,
                        username: e.target.value,
                      })}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      id="exampleInputPassword1"
                      placeholder="Password"
                      onChange={(e)=>setUserInfo({
                        ...userInfo,
                        password: e.target.value,
                      })}
                    />
                  </div>
                  <div className="mt-3">
                    <button className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" onClick={(e)=>handleSubmit(e)}>SIGN IN</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
